import Text from '../../Text'

import * as styles from './ButtonSelectControlContentPlaceholder.module.css'

function ButtonSelectControlContentPlaceholder({
  Element = Text,
  className = styles.ButtonSelectControlContentPlaceholder,
  text,
}) {
  return <Element className={className}>{text}</Element>
}

export default ButtonSelectControlContentPlaceholder
